import { BusinessRules } from '../BusinessRules';

import compMsgAcompanhamentoBoletoPosEntrada
  from '../components/itau/msgAcompanhamentoBoletoPosEntrada.vue';
import compMsgBoletoSemOperacao from '../components/itau/msgBoletoSemOperacao.vue';
import compMsgCancelamentoErroApi from '../components/itau/msgCancelamentoErroApi.vue';
import compMsgCancelamentoErroIndisponibilidade from '../components/itau/msgCancelamentoErroIndisponibilidade.vue';
import compMsgCancelamentoSucesso from '../components/itau/msgCancelamentoSucesso.vue';
import compMsgCancelamentoViaCredor from '../components/itau/msgCancelamentoViaCredor.vue';

const rules: Partial<BusinessRules> = {
  compMsgAcompanhamentoBoletoPosEntrada,
  compMsgBoletoSemOperacao,
  compMsgCancelamentoSucesso,
  compMsgCancelamentoViaCredor,
  compMsgCancelamentoErroApi,
  compMsgCancelamentoErroIndisponibilidade,
  contatos: [
    {
      title: 'Clientes não correntistas',
      values: ['São Paulo: 3003 3030', 'Outras localidades: 0800 720 3030'],
    },
    {
      title: 'Clientes correntistas',
      values: ['São Paulo: 4004 1144', 'Outras localidades: 0800 726 1144'],
    },
  ],
  showValorOriginal: false,
  permiteCancelarViaCredor: true,
  permiteNegociacaoParcial: true,
  showAvisoValorOfertaAteVencimento: (totalParcelas) => totalParcelas > 1,
  showLogoTelaBoletos: (p) => p?.parcelasGerenciadas?.demaisParcelas === false
    && (p.parcelasGerenciadas.primeiraParcela === false
      || p.parcelas?.find((b) => b.numeroParcela === 1)?.quitada === true),
  showAvisoSenhaBoleto: true,
  mensagemTermoCondicoesGerais: 'Ao renegociar, o teto de juros do cartão de crédito limitado a 100% do valor original da dívida não se aplica neste novo contrato. Ao continuar, você declara que leu e concorda com as informações importantes, os detalhes desta renegociação e os',
  mensagemUrlTermoCondicoesGerais: 'termos e condições do Itaú',
  mensagemAutorizacaoDebitoConta: 'Após pagar a primeira parcela, não será possível cancelar o contrato. Você poderá quitar ou renegociar novamente o contrato.',
  mensagemAcompanhamentoAplicativo: 'Após o pagamento da primeira parcela, o restante da sua negociação poderá ser acompanhado diretamente no canal Itaú.',
  mensagemColchaoNaoGerenciado: 'Todas as atualizações das negociações com o Itaú devem ser acompanhadas exclusivamente através do seu portal. Nele você encontrará informações detalhadas sobre o status dos seus pagamentos.',
  nomeAplicativo: 'Itaú',
  linkCanalOficial: 'https://www.itau.com.br/',
};

export default rules;
